const app = angular
  .module('msi.core.config', [require('../constants')])

  .config(require('./log'))
  .config(require('./sdk'));

module.exports = app.name;
